import type {ReactElement} from 'react';
import React from 'react';
import {BaseItemEdgeEffectsOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-edge-effects-option';
import type {EdgeType} from '@PosterWhiteboard/classes/item-effects.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromEffectsOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveSlideItem';

export function SlideshowItemEffectsOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const edgeType = useGetKeyFromEffectsOfActiveSlideItem('edgeType');
  const edgeThickness = useGetKeyFromEffectsOfActiveSlideItem('edgeThickness');

  if (!activeItem || !activeSlideUID) {
    throw new Error('Active item or active slide is not defined in slideshow item effects options');
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected active item to be of type slideshow, got ${activeItem.gitype} instead`);
  }

  if (edgeThickness === undefined || edgeType === undefined) {
    throw new Error('Unable to find edge thickness or edge type for slideshow item');
  }

  const applyEffect = (valueToApply: EdgeType): void => {
    if (edgeType === valueToApply) {
      return;
    }

    void activeItem.updateSlideFromObject(activeSlideUID, {
      effects: {
        edgeType: valueToApply,
      },
    });
  };

  const onChangeEdgeThickness = (edgeThickness: number, undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        effects: {
          edgeThickness,
        },
      },
      {undoable}
    );
  };

  return (
    <BaseItemEdgeEffectsOption
      edgeThickness={edgeThickness}
      edgeType={edgeType}
      applyEffect={applyEffect}
      onChangeThickness={onChangeEdgeThickness}
      showCurvedEffect={!activeItem.getSelectedSlide().isVideoSlide()}
    />
  );
}
